import { render } from "./TripPrice.vue?vue&type=template&id=8fabc5f2&scoped=true"
import script from "./TripPrice.vue?vue&type=script&lang=js"
export * from "./TripPrice.vue?vue&type=script&lang=js"

import "./TripPrice.vue?vue&type=style&index=0&id=8fabc5f2&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fabc5f2"]])

export default __exports__